export default "__VITE_ASSET__C2w7jfqB__"